export default __webpack_public_path__ + "static/media/leg-icon-state.fc1ea52c.png";